import React from "react";
import "./LSQFrame.css";
const LSQFrame = ({ children, type = "frame1", className, role }) => {
  return (
    <div className={`lsq-frame ${className} ${type}`} role={role}>
      {children}
    </div>
  );
};

export default LSQFrame;
